import { R } from '@core/utils/r';

export interface CourseStepDefination {
  label: string;
  icon: string;
}

export enum CourseStepType {
  docuemnt = 'document',
  video = 'video',
  test = 'test',
  policy = 'policy',
  //   article = 'article',
  todoList = 'todoList',
  scenarioDrill = 'scenarioDrill',
  statementDrill = 'statementDrill',
  sequenceDrill = 'sequenceDrill',
  listMatching = 'listMatching',
  procedure = 'procedure',
  flowCharts = 'flowCharts',
  jobDescriptions = 'jobDescriptions',
  glossary = 'glossary',
}

export const StepDefinations: Record<CourseStepType, CourseStepDefination> = {
  document: { label: 'Document', icon: 'bx bx-file-blank' },
  video: { label: 'Video', icon: 'bx bx-video' },
  test: { label: 'Test', icon: 'bx bx-dock-top' },
  policy: { label: 'Policy', icon: 'bx bx-file' },
  //   article: { label: 'Article', icon: 'bx bx-book' },
  todoList: { label: 'Todo List', icon: 'bx bx-list-check' },
  scenarioDrill: { label: 'Scenario Drill', icon: 'bx bx-message-rounded-dots' },
  statementDrill: { label: 'Statement Drill', icon: 'bx bx-message-dots' },
  sequenceDrill: { label: 'Sequence Drill', icon: 'bx bx-list-ul' },
  listMatching: { label: 'List Matching', icon: 'bx bx-list-minus' },
  procedure: { label: 'Procedure', icon: 'bx bx bx-book' },
  flowCharts: { label: 'Flow Charts', icon: 'bx bx-transfer' },
  jobDescriptions: { label: 'Job Descriptions', icon: 'bx bx-award' },
  glossary: { label: 'Glossary', icon: 'bx bx-book' },
};

export const COURSE_STEP_TYPES = R.keys(StepDefinations) as CourseStepType[];
